import { NavigationExtras, Params } from '@angular/router';

export enum RouteType {
  PAGE,
  DASHBOARD,
  WIZARD
}

export interface INavigationItem {
  label?: string;
  type?: string;
  typeId?: string;
  outlet?: string;
  navigation?: string | string[];
  queryParams?: Params;
}

export interface NavigationProviderCommands {
  navigatePerspective(id): NavigationProviderCommands;
  navigateToPage(pageOutletParams, navigationExtras?: NavigationExtras);
  navigateToWizard(wizardOutletParams, navigationExtras?: NavigationExtras);
  navigateToDashboard(dashboardOutletParams, navigationExtras?: NavigationExtras);
  navigateToTestSetup(wizardOutletParams, navigationExtras?: NavigationExtras);
  //eslint-disable-next-line
  addRootParam(topic: string, value: any): NavigationProviderCommands;
}
export abstract class NavigationProvider implements NavigationProviderCommands {
  /**
   * Navigate using router by Type
   * @param item: INavigationItem - Information describing the route to navigate to
   */
  //eslint-disable-next-line
  public navigateByType(item: INavigationItem): void {
    console.error('NavigationProvider::navigateByType has not been implemented');
  }

  /**
   * Navigate using the router by Outlet
   * @param item: INavigationItem - Information describing the route to navigate to
   */
  //eslint-disable-next-line
  public navigateByOutletParams(item: INavigationItem): void {
    console.error('NavigationProvider::navigateByOutletParams has not been implemented');
  }

  abstract navigatePerspective(id: string): NavigationProviderCommands;
  //eslint-disable-next-line
  abstract navigateToPage(pageOutletParams: any, navigationExtras?: NavigationExtras);
  //eslint-disable-next-line
  abstract navigateToWizard(wizardOutletParams: any, navigationExtras?: NavigationExtras);
  //eslint-disable-next-line
  abstract navigateToDashboard(dashboardOutletParams: any, navigationExtras?: NavigationExtras);
  //eslint-disable-next-line
  abstract navigateToTestSetup(wizardOutletParams: any, navigationExtras?: NavigationExtras);
  /**
   * Some projects may store parameters of the next route on the URL. If we trigger
   * two navigations (eg, first one to 'put' value of parameter on the URL, and a second
   * one to navigate to the route), angular will cancel the first one..
   * To avoid this problem, the code can say it needs to 'set' root param value and
   * then call 'navigateToXX' method. This way, those 2 navigations can be merged into
   * one.
   * @param topic
   * @param value
   */
  //eslint-disable-next-line
  abstract addRootParam(topic: string, value: any): NavigationProviderCommands;

  /**
   * Useful for removing hanging queryParams after using them, for handling navigation to same
   * page from multiple other pages with or without queryParams;
   * using this page-state solution, we should be able to permit navigation without queryParams,
   * after we did it with certain ones
   */
  //eslint-disable-next-line
  abstract removeQueryParams(routeType: RouteType, routeName: string, queryNames: string[]);
}
